import { Suspense } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";
import { useSearchParams } from "react-router";

import { createSingleFilter } from "app/utils/filters";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import {
  type FilterElementInput,
  type GroupsSettingsRootQuery,
} from "./__generated__/GroupsSettingsRootQuery.graphql";
import { AccessControlSettingsPage } from "./AccessControlSettingsPage";
import { Groups } from "./Groups/Groups";
import { GroupsActionBar } from "./GroupsActionBar";

export function GroupsSettingsRoot() {
  const [searchParams, setSearchParams] = useSearchParams({});
  const search = searchParams.get("search");
  const expanded = searchParams.get("expanded");
  const isExpanded = expanded === "true";

  const groupsFilterElement: FilterElementInput | undefined = search
    ? createSingleFilter("name", search, "contains")
    : undefined;

  const data = useLazyLoadQuery<GroupsSettingsRootQuery>(
    graphql`
      query GroupsSettingsRootQuery(
        $groupsFilterElement: FilterElementInput
        $groupsOrder: String
      ) {
        ...AccessControlSettingsPage_query
        ...GroupsTable_query
          @arguments(filterElement: $groupsFilterElement, order: $groupsOrder)
      }
    `,
    {
      groupsFilterElement,
      groupsOrder: "name",
    },
  );

  const handleExpandedChange = (expanded: boolean) => {
    setSearchParams({ expanded: expanded ? "true" : "false" });
  };

  return (
    <AccessControlSettingsPage pageTitle="Groups" queryRef={data}>
      <SettingsTabsLayout>
        <div className="flex w-full flex-col">
          <GroupsActionBar
            isExpanded={isExpanded}
            onExpandedChange={handleExpandedChange}
          />

          <Suspense fallback={null}>
            <Groups
              expanded={isExpanded}
              filterElement={groupsFilterElement}
              order="name"
              queryRef={data}
            />
          </Suspense>
        </div>
      </SettingsTabsLayout>
    </AccessControlSettingsPage>
  );
}
